<kit-page-header [section]="'Offering grants'"
                 [title]="'View and manage user roles and permissions'"
                 [fullWidthDescription]="true"
                 [description]="'Manage users that have been granted access to individual roles.'"
></kit-page-header>

@if (loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="fx-col page-padding page-content fx-gap-20">
  @for (ungroupedRole of ungroupedGrantedRoles; track ungroupedRole) {
    <app-crud-table
      [title]="ungroupedRole.roleName"
      [subTitle]="ungroupedRole.roleCode + ':' + ungroupedRole.roleDescription"
      [modelType]="grantsModelType"
      [loading$]="loading$"
      [tableData]="ungroupedRole.users"
      [additionalActions]="additionalActions"
      [updatedRow]="updatedRow">
    </app-crud-table>

    <mat-divider></mat-divider>
  }

</div>
